module.exports = {"user":{"no":"no.","name":"Name","empId":"Employee Id","isAdmin":"Is Admin","isNpiAdmin":"Is Npi","manage":"Manage Users","costCenterName":"Cost Center","viewList":"View Users","manageNpi":"Manage NPI admin","manageAdmin":"Manage Admin","edit":"Edit","submitNpiPermit":"Submit","cancel":"Cancel","backToList":"Back to List","manageSubmit":"Manage Submit","manageApprove":"Manage Approve","isSubmit":"Is Submit","isApprove":"Is Approve","":""}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/en/user.json
// module id = 550
// module chunks = 35